import { post,postForm,get } from "helpers/api_helper/ApiHelpers/apiHelpers"
import * as url from "helpers/url_helper/url_helper"

export const getUsersMerchantApplicationList = record => post(url.USERS_MERCHANT_APPLICATION, record)
export const addMerchantApplication = record => postForm(url.MERCHANT_APPLICATION_INSERT, record)
export const getUserCanMakeApplication = record => post(url.USER_CAN_MAKE_APPLICATION, record)
export const getUserCanApproveAgreement = record => post(url.USER_CAN_APPROVE_AGREEMENT, record)
export const approveMerchantAgreement = record => post(url.APPROVE_MERCHANT_AGREEMENT, record)
export const deleteMerchantFile = record => post(url.DELETE_MERCHANT_FILE, record)
export const uploadMerchantFile = file => postForm(url.UPLOAD_MERCHANT_FILE+"?documentType="+file.DocumentType, file.file)
export const uploadMerchantFileList = files => postForm(url.UPLOAD_MERCHANT_FILE_LIST, files)
export const getMerchantApplicationDocumentList = applicationGuid =>post(url.GET_MERCHANT_APPLICATION_DOCUMENT, applicationGuid)
export const getMerchantFileBySubMerchantId = subMerchantId =>post(url.GET_MERCHANT_FILE_SUBMERCHANTID, subMerchantId)


